import {InjectionToken} from '@angular/core'
import {NewOrderEmbeddedService} from '@service/orders/new/new-order.embedded.service'
import {NewOrderService} from '@service/orders/new/new-order.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `NewOrderService`.
 *
 * @description
 * Devuelve `NewOrderEmbeddedService` en modo embebido y `NewOrderService`
 * en modo standalone. `NewOrderService` orquesta el flujo de creación de
 * un pedido nuevo (selección de catálogo, distribuidor, líneas iniciales
 * y persistencia del borrador).
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `NewOrderService`.
 */
export function providerNewOrderFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new NewOrderEmbeddedService() : new NewOrderService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `NewOrderService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con {@link providerNewOrderFactory}.
 */
export const NewOrderServiceToken = new InjectionToken<NewOrderService>('NewOrderService')
